import { useTranslation } from "react-i18next"

import { Textarea } from "shared/ui/input/text/Textarea"

import { MAX_LENGTH_CLARIFICATION_REQUEST } from "../types/ClarificationRequest"

interface ClarificationRequestFormTextAreaProps {
  name?: string
  readonly?: boolean
}

export function ClarificationRequestFormTextArea({
  name,
  readonly
}: ClarificationRequestFormTextAreaProps) {
  const { t } = useTranslation()

  return (
    <Textarea.Root
      name={name}
      label={t("ClarificationRequest.Form.Content.Label")}
      readonly={readonly}
      maxLength={MAX_LENGTH_CLARIFICATION_REQUEST}
    >
      <Textarea.Label />
      <Textarea.Focus>
        <Textarea.Input rows={5} />
        <Textarea.Counter />
      </Textarea.Focus>
      <Textarea.Readonly />
    </Textarea.Root>
  )
}
